import { Building2, Store, Users } from 'lucide-react';

export interface WizardUser {
  email: string;
  first_name: string;
  last_name: string;
  roles: string[];
}

export interface WizardSubOrg {
  name: string;
  email: string;
  users?: WizardUser[];
}

export interface WizardFormData {
  name: string;
  email: string;
  phone?: string;
  is_active: boolean;
  is_reseller: boolean;
  parent_organization_id?: number;
  max_users: number;
  plan_id?: number;
  auto_renew: boolean;
  users: WizardUser[];
  sub_organizations: WizardSubOrg[];
}

export type CustomerType = 'direct' | 'reseller' | 'sub_org';

export const CUSTOMER_TYPE_OPTIONS: {
  type: CustomerType;
  icon: typeof Building2;
  color: string;
  bgColor: string;
}[] = [
  {
    type: 'direct',
    icon: Building2,
    color: 'rgb(59, 130, 246)',
    bgColor: 'rgba(59, 130, 246, 0.10)'
  },
  {
    type: 'reseller',
    icon: Store,
    color: 'rgb(139, 92, 246)',
    bgColor: 'rgba(139, 92, 246, 0.10)'
  },
  {
    type: 'sub_org',
    icon: Users,
    color: 'rgb(16, 185, 129)',
    bgColor: 'rgba(16, 185, 129, 0.10)'
  }
];

export const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'financial', label: 'Financial' },
  { value: 'developer', label: 'Developer' },
  { value: 'contributor', label: 'Contributor' }
];
